<div class="organization-modal modal-content" piqetAngularDraggable>
  <div class="modal-header header-modal">
    <span class="bootstrap-dialog-title">{{ modalLabel }} </span>
    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>

  <div class="modal-body body-modal">
    <form [formGroup]="newsAddEditForm">
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group required">
            <div class="services-form">
              <div class="ngbdate">
                <input
                  type="text"
                  [bsConfig]="newsConfig"
                  #hiddenStart
                  formControlName="date"
                  [readonly]="true"
                  [(ngModel)]="startDateInput"
                  bsDatepicker
                  placeholder="Date *"
                  placement="bottom"
                />
                <label>Date</label>
              </div>
            </div>
            <div
              *ngIf="(submitted || newsAddEditForm.controls['date'].touched) && (newsAddEditForm.controls['date'].errors?.['required'] || newsAddEditForm.controls['date'].status === 'INVALID'  )"
            >
              <div
                *ngIf="newsAddEditForm.controls['date'].errors?.['required'] || newsAddEditForm.controls['date'].status === 'INVALID'  "
                class="input-error"
              >
                Date is required
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group required">
            <div class="form-group required" aria-required="true">
              <div class="services-form">
                <input type="text" placeholder="Subject" formControlName="subject" />
                <label>Subject</label>
              </div>
              <div
                *ngIf="
                  (submitted || this.newsAddEditForm.controls['subject'].touched) &&
                  this.newsAddEditForm.controls['subject']?.errors
                "
                class="input-error"
              >
                Subject is required.
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <label>Description *</label>
          <ckeditor
            [(ngModel)]="description"
            (input)="changeEve($event)"
            formControlName="description"
            [config]="ckEditorConfig"
          ></ckeditor>
          <div
            *ngIf="
              (submitted || this.newsAddEditForm.controls['description'].touched) &&
              this.newsAddEditForm.controls['description']?.errors
            "
            class="input-error"
          >
            Description is required.
          </div>
        </div>
      </div>

      <div class="row checkbox-text-margin mt-4">
        <div class="col-sm-2 mt-2" class="checkbox-text checkBoxAlienMent">
          <input
            type="checkbox"
            class="chkOverview"
            [ngModelOptions]="{ standalone: true }"
            [(ngModel)]="isNotify"
            (change)="notify($event)"
          />
          <span> Notify user</span>
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer text-margin">
    <button type="button" class="cancelBtn" (click)="onClose()">Cancel</button>
    <button type="button" class="modelBtn purpleBtnHoverEffect" (click)="onSave()">Save</button>
  </div>
</div>
